import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectHasSession } from "../store/sessionSlice";
import { useNavUtils } from "../utils/navUtils";

export default function RequireSession() {
  const hasSession = useSelector(selectHasSession);
  const location = useLocation();
  const { getSessionCreationTarget, getNav } = useNavUtils();

  // If a session already exists, or the URL carries a join-token, let the user through
  const params = new URLSearchParams(location.search);
  const hasJoinToken = params.has("join_token");

  if (hasSession || hasJoinToken) {
    return <Outlet />;
  }

  const destination = getNav(getSessionCreationTarget(), { includeParams: true });
  return <Navigate to={destination} state={{ from: location }} replace />;
}
